import JSZip from 'jszip';
import { RedactSession, buildManifest } from './registryUtils';

export interface ExportableFile {
  result: string
  autoName?: string
  studentToken?: string
  file: File
  status: string
}

export async function exportNotebookPack(
  files: ExportableFile[],
  session: RedactSession,
  showWatermark: boolean
): Promise<void> {
  const completed = files.filter((f) => f.status === 'success' && f.result);
  if (completed.length === 0) return;

  const zip = new JSZip();

  for (const file of completed) {
    const token = file.studentToken ?? 'UNSORTED';
    const rawName = file.autoName ?? `redacted_${file.file.name}`;
    const filename = rawName.replace(/\.[^/.]+$/, '') + '.txt';
    const content = showWatermark
      ? `${file.result}\n\n---\nRedacted with Redact AI`
      : file.result;

    const folder = zip.folder(token);
    folder?.file(filename, content);
  }

  // Manifest — always included, labeled clearly
  zip.file('MANIFEST_KEEP_LOCAL.txt', buildManifest(session));

  const blob = await zip.generateAsync({ type: 'blob' });
  const today = new Date().toISOString().split('T')[0];
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `notebook_pack_${today}.zip`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
